var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "linkedin-contact-list-switcher" },
    [
      _c("LinkedinContactList", {
        attrs: {
          channelId: _vm.selectedChannelId,
          channel: _vm.getSelectedChannel(),
          "show-title": false,
          "allow-import": "",
          forbidden: _vm.isForbidden(_vm.getSelectedChannel()),
          allChannelMode: _vm.allChannel,
        },
        scopedSlots: _vm._u([
          {
            key: "left-actions",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "channel-switcher" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex gap-5" },
                      [
                        _c("a-switch", {
                          model: {
                            value: _vm.allChannel,
                            callback: function ($$v) {
                              _vm.allChannel = $$v
                            },
                            expression: "allChannel",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("instagram.showAllLinkedinChannels"))
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.allChannel
                      ? _c("ChannelPicker", {
                          attrs: {
                            "auto-select-first": "",
                            "include-deleted": "",
                            "allowed-types": ["linkedin-unipile"],
                            disabled: _vm.allChannel,
                          },
                          model: {
                            value: _vm.selectedChannelId,
                            callback: function ($$v) {
                              _vm.selectedChannelId = $$v
                            },
                            expression: "selectedChannelId",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }